import React, { useMemo, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

const ORDER = ["Valentine's", "Mother's Day", "Easter", "Father's Day", "Black Friday", "Christmas", "Custom"];
const COLORS = ["#16243b", "#2ec9c9", "#f43f5e", "#f59e0b", "#8b5cf6", "#10b981"];

export const CampaignChart = ({ rows }) => {
  const [metric, setMetric] = useState("revenue");
  const { data, years } = useMemo(() => {
    const years = [...new Set(rows.map((r) => r.year))].sort();
    const groups = {};
    rows.forEach((r) => {
      const g = (groups[r.preset_label] = groups[r.preset_label] || { holiday: r.preset_label });
      g[r.year] = Math.round(((g[r.year] || 0) + (metric === "revenue" ? r.revenue : r.sold)) * 100) / 100;
    });
    const data = Object.values(groups).sort((a, b) => ORDER.indexOf(a.holiday) - ORDER.indexOf(b.holiday));
    return { data, years };
  }, [rows, metric]);

  return (
    <div className="mb-6" data-testid="campaign-chart">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-medium text-[#16243b]">Holidays compared year on year</p>
        <div className="inline-flex rounded-full bg-[#f6f8fb] p-1 text-xs">
          {[["revenue", "Revenue"], ["sold", "Vouchers sold"]].map(([k, l]) => (
            <button key={k} onClick={() => setMetric(k)} data-testid={`campaign-metric-${k}`}
              className={`rounded-full px-3 py-1.5 font-medium transition-colors ${metric === k ? "bg-[#16243b] text-white" : "text-[#5a6b80]"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="h-[260px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eef1f5" vertical={false} />
            <XAxis dataKey="holiday" tick={{ fontSize: 12, fill: "#5a6b80" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 12, fill: "#8a97a8" }} axisLine={false} tickLine={false} allowDecimals={metric === "revenue"}
              tickFormatter={(v) => (metric === "revenue" ? `£${v}` : v)} />
            <Tooltip formatter={(v) => (metric === "revenue" ? `£${Number(v).toFixed(2)}` : v)} cursor={{ fill: "#f6f8fb" }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            {years.map((y, i) => <Bar key={y} dataKey={String(y)} name={String(y)} fill={COLORS[i % COLORS.length]} radius={[6, 6, 0, 0]} maxBarSize={36} />)}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
